import { buildScopedI18n } from '../../utils/buildScopedI18n';
import campaignsEsCL from './locales/es-CL.json';
import campaignsEnUS from './locales/en-US.json';
import campaignsPtBR from './locales/pt-BR.json';

export const campaignsI18n = buildScopedI18n({
  esCL: campaignsEsCL,
  enUS: campaignsEnUS,
  ptBR: campaignsPtBR,
});
